import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../../layer/ILoaderProps';
import { LoadableSource } from '../../../layer/LoadableSource';
import { Config } from '../../../../Config';

interface IPondProps {
  id: string;
  uuid: string;
}

const Ponds = (props: ILoaderProps & IPondProps) => 
  <LoadableSource path={`https://apigeostore.longline.co.uk/dataset/${props.uuid}`} ignore={["id", "ADM0_EN", "continent"]} {...props}>
    <Layer
      id={props.id}
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        'fill-color': "orange",
        'fill-opacity': [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          0.8,
          0.5
        ]
      }}
    />
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{
        "line-color": "#B68500",
        'line-width': 1
      }}
    />
  </LoadableSource>

export { Ponds } 

